module.exports = __webpack_public_path__ + "img/checkmark-loading.74e61d1e.svg";